import { config } from "../../config";

import { ApiError } from "../error-handler";
import { getHandler } from "../request-handler";

// Autocomplete addresses
export interface IAddressSuggestion {
  suggestion: string;
  urls: {
    udprn: string;
  };
  udprn: number;
}

export interface IAddressAutocomplete {
  suggestion: string;
  urls: {
    udprn: string;
  };
  udprn: number;
}

interface IAddressAutocompleteResponse {
  result: {
    hits: IAddressAutocomplete[];
  };
  code: number;
  message: string;
}

/**
 * Send request to ideal-postcodes API
 * to get suggestions list based on address or postcode
 */
export async function getSuggestedAddresses(
  address: string,
): Promise<IAddressAutocomplete[]> {
  const limitResults = 10;
  const endPoint = `${config.idealPostcodesApi.path}/autocomplete/addresses?api_key=${config.idealPostcodesApi.token}&query=${address}&limit=${limitResults}`;

  const res = await fetch(endPoint);
  const response: IAddressAutocompleteResponse =
    (await res.json()) as IAddressAutocompleteResponse;

  return response.result.hits;
}

// Address by UDPRN
export interface IAddress {
  postcode: string;
  postcode_inward: string;
  postcode_outward: string;
  post_town: string;
  building_number: string;
  building_name: string;
  udprn: number;
  line_1: string;
  line_2: string;
  country: string;
  longitude: number;
  latitude: number;
}

interface IAddressResponse {
  result: IAddress;
  code: number;
  message: string;
}

/**
 * Send request to ideal-postcodes API
 * to get address by udprn
 */
export async function getAddressByUdprn(udprn: number): Promise<IAddress> {
  const endPoint = `${config.idealPostcodesApi.path}/addresses/${udprn}?api_key=${config.idealPostcodesApi.token}`;

  const res = await fetch(endPoint);
  const response: IAddressResponse = (await res.json()) as IAddressResponse;

  return response.result;
}

interface ISupportedPostcode {
  isSupported: boolean;
}

/**
 * Check supported postcode
 */
export async function checkSupportedPostcode(
  postcode: string,
): Promise<boolean> {
  const endPoint = `/postcodes/${postcode}/supported`;

  const response = await getHandler<ISupportedPostcode>(endPoint, false);

  if (response.error) {
    throw new ApiError(response.error);
  }

  return response.result.isSupported;
}
